import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../config/apiClient";
import API_ENDPOINTS from "../config/api";

const initialState = {
  results:       [],
  loading:       false,
  error:         null,
  filter:        {},
  current_page:  1,
  total_pages:   0,
  total:         0,
  per_page:      20,
};

export const fetchFilterResults = createAsyncThunk(
  "filter/fetchFilterResults",
  async ({ type, genre, tag, year, page = 1 }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({ type, page, limit: 20 });
      if (genre) params.append("genre", genre);
      if (tag)   params.append("tag",   tag);
      if (year)  params.append("year",  year);

      const res = await apiClient.get(`${API_ENDPOINTS.FILTER}?${params.toString()}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    clearFilter: (state) => {
      state.results      = [];
      state.filter       = {};
      state.total        = 0;
      state.total_pages  = 0;
      state.current_page = 1;
      state.error        = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFilterResults.pending, (state) => {
        state.loading = true;
        state.error   = null;
      })
      .addCase(fetchFilterResults.fulfilled, (state, action) => {
        state.loading      = false;
        state.results      = action.payload.data;
        state.filter       = action.payload.filter;
        state.current_page = action.payload.current_page;
        state.total_pages  = action.payload.total_pages;
        state.total        = action.payload.total;
        state.per_page     = action.payload.per_page;
      })
      .addCase(fetchFilterResults.rejected, (state, action) => {
        state.loading = false;
        state.error   = action.payload;
      });
  },
});

export const { clearFilter } = filterSlice.actions;
export default filterSlice.reducer;